module.exports = __webpack_public_path__ + "img/uploadphoto.bf7c5a77.png";